import { gql, useQuery } from "@apollo/client";
import {
  FindIsInterestedQueryQuery,
  QueryFindIsInterestedArgs,
} from "../../../../schemaTypes";

export const findIsInterestedQuery = gql`
  query FindIsInterestedQuery(
    $merchantUserId: String!
  ) {
    findIsInterested(
      merchantUserId: $merchantUserId
    ) {
      errors {
        path
        message
      }
      message
      status
    }
  }
`;

export const useFindIsInterested = (
  variables: QueryFindIsInterestedArgs
) => {

  const { data, loading, refetch } = useQuery<
    FindIsInterestedQueryQuery,
    QueryFindIsInterestedArgs
  >(findIsInterestedQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  return {
    loading,
    status: data?.findIsInterested?.status ?? false,
    message: data?.findIsInterested?.message ?? null,
    errors: data?.findIsInterested?.errors ?? null,
    refetch
  };
};